import Vue from 'vue'
/**
 * @author  Mariela T. TL. <mariela.temozihui@jbge.com.mx>
 *
 *
 * Set affected visible repports
 *
 * @return true or false
 */
const affectedVisibleRepports = (id, isAffected) =>
  Vue.$http.put(`sinisters/affected/${id}/`, isAffected)
    .then()
    .catch(err => { throw err })

export default affectedVisibleRepports



// WEBPACK FOOTER //
// ./src/services/sinister/affectedVisibleRepports.js